import { Inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Guid } from 'guid-typescript';
import * as moment from 'moment';
import { defineLocale } from 'ngx-bootstrap/chronos';
import * as locales from 'ngx-bootstrap/locale';
import { DisplayIndicatedReference } from '../../components/slotbooking/slotcalendar/slotcalendar.model';
import { HttpService } from './http.service';
import { Spa } from 'app/model/spa/backend-api-response/spa';
import { SpaPropertyInfoApiResponse } from 'app/model/spa/backend-api-response/spa-property-info-api-response';
import { GoogleAnalyticsScriptService } from '../../../../../shared/services/google-analytics-script.service';
import { PropertySettings } from 'model/shared/backend-api-response/property-settings';

declare let ga: Function;
export class IDGenerator {
  length = 8;
  timestamp = +new Date();
  value: any;
  constructor() {
    this.value = this.generate();
  }

  _getRandomInt(min, max) {
    const crypto = window.crypto || window['mscrypto'];
    const random = Number('0.' + crypto.getRandomValues(new Uint32Array(1))[0]);
    return Math.floor(random * (max - min + 1)) + min;
  }

  generate() {
    var ts = this.timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (const _len of new Array(this.length).fill(0)) {
      var index = this._getRandomInt(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }
}

const AZURE_BLOB_STORAGE_URL = '/generateAzureBlobStorageSAS';
const ADMIN_SERVICE_URL = '/wbe-admin-service';
@Injectable({
  providedIn: 'root',
})
export class SpaAppDataService {
  public tenantId: string = '';
  public propertyId: string = '';
  private configURL: string = '';
  private middlewareAPIDomain: string = '';
  public therapistDisplayIndicator: any = 'name';
  public propertyInfo: SpaPropertyInfoApiResponse;
  private appName: string = 'spa';
  public serviceHeaders: any;
  public tenantFound: boolean = false;
  public bookingDaysOut: number = 999;
  public cloudPropertyData: Spa;
  public dateFunctionConfig = {
    locale: 'enUS',
    dateFormat: 'dd/MM/yyyy',
    dateMediumFormat: 'MMM dd, yyyy',
    weekNameFormat: 'EEEE',
    timeFormat: 'hh:mm a',
  };
  public isGoogleTagManager = false;
  public tagGoogleManagerId = ''; //GTM-WW8GW8R
  public propertyname_book: string = '';
  public propertyname_config: string = '';
  public transactionID;
  // public phoneNumberFormat: string = '';
  public userID: any;
  private guestCount: any;
  private errorMessage: string;
  public irameTime: number = 9000;
  public countryCodeKey: any;
  styleTag: any;
  public noEmailTrigger: boolean = false;
  public confirmationNumberLength = 50;
  public cartLimit = 100;
  public paymentRetryInterval: any = 5000;
  public paymentRetryCounter: any = 10;
  public configData: string = 'wbe-property-service/property';
  public configUrl: string = 'wbe-property-service/property';
  public currentPropertyDate: any;
  public tenantNotFoundData: any;

  private cloudHeader: any;
  public configDetailsData: any;
  public tenants: any;
  // public APIContext: any;
  public cloudBackendDomain: any;
  private cloudContextTenants: any;
  cloudContextTenents: any;
  displayindicatedReference: DisplayIndicatedReference = {
    verifyName: 'name',
    verifyCode: 'code',
    verifyaka: 'aka',
    noDisplay: 'noDisplay',
  };

  //middlewareAPIPropertyNames
  public propertyAPIName: string = 'wbe-property-service/property';
  public cookieRequired: boolean = false;
  public isCookiePolicyAcceptanceRequired: boolean = false;
  public policyCookie: boolean;
  public cookieExpDays: any;
  public pageTitle: any;
  public spaCloudConfig: boolean = false;
  public langCode: any;
  azureAccountUrl: string = environment.azureAccountUrl;
  public ga4Data!: {
    gaAgilysysId: string;
    gaCustomerId: string;
    isCustGaId: boolean;
  };
  private propertySettings: PropertySettings | undefined;
  constructor(public http: HttpService, private googleScript: GoogleAnalyticsScriptService) {}

  async load(middlewareAPIDomain, tenantId, propertyId, appName, serviceHeaders) {
    this.middlewareAPIDomain = middlewareAPIDomain;
    this.tenantId = tenantId;
    this.propertyId = propertyId;

    this.appName = appName;
    this.serviceHeaders = serviceHeaders;

    return this.initialAPI().then(async () => {
      return this.propertyAPI().then(async () => {
        return true;
      });
    });
  }

  defineLocales() {
    for (const locale in locales) {
      if (this.cloudPropertyData.countryCode.toLowerCase() === locales[locale].abbr) {
        defineLocale(locales[locale].abbr, locales[locale]);
      }
    }
  }
  getAnalyticsData(a, b) {
    let gaData = localStorage.getItem(`${a}-${b}-AnalyticsId`);
    if (!gaData) {
      this.userID = new IDGenerator().value;
    } else {
      this.userID = gaData;
    }
  }

  private loadGoogleScript(propertySettings?: PropertySettings): void {
    this.ga4Data = {
      gaAgilysysId: environment?.GaAgilysysId || '',
      gaCustomerId: propertySettings?.gaCustomerId || '',
      isCustGaId: propertySettings?.isCustGaId || false,
    };

    sessionStorage.setItem('GA4Data', JSON.stringify(this.ga4Data));

    this.ga4Data && this.googleScript.loadGoogleScript();
  }

  async initialAPI() {
    let transID = localStorage.getItem(`${this.tenantId}-${this.propertyId}-transactionID`);
    if (transID == 'undefined' || transID === null) {
      this.generateUniqueID(this.tenantId, this.propertyId);
    } else {
      this.transactionID = JSON.parse(localStorage.getItem(`${this.tenantId}-${this.propertyId}-transactionID`)).value;
    }
    let url =
      this.middlewareAPIDomain +
      '/' +
      this.propertyAPIName +
      '/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.propertyId +
      '/appName/' +
      this.appName +
      '?' +
      new Date().getTime() +
      '&appName=spa';
    return this.http
      .get(url, this.serviceHeaders)
      .toPromise()
      .then(async (response: Spa) => {
        if (response['Success']) {
          this.propertySettings = response?.propertySettings;

          this.setPropertyData(response);
          return this.setProperty().then(() => {
            return true;
          });
        } else {
          this.tenantFound = false;
          return true;
        }
      });
  }

  private setPropertyData(response: Spa): void {
    this.tenantFound = true;
    this.cloudPropertyData = response;
    this.dateFunctionConfig = this.cloudPropertyData.dateFunctionConfig
      ? this.cloudPropertyData.dateFunctionConfig
      : this.dateFunctionConfig;
    if (this.cloudPropertyData.currencyCode) this.defineLocales();
    this.isGoogleTagManager = this.cloudPropertyData.isGoogleTagManager
      ? this.cloudPropertyData.isGoogleTagManager
      : this.isGoogleTagManager;
    this.langCode = this.cloudPropertyData.langCode ? this.cloudPropertyData.langCode.toUpperCase() : 'EN';
    this.tagGoogleManagerId = this.cloudPropertyData.tagGoogleManagerId
      ? this.cloudPropertyData.tagGoogleManagerId
      : this.tagGoogleManagerId;
    this.spaCloudConfig = this.cloudPropertyData.spaConfigCloud ? this.cloudPropertyData.spaConfigCloud : false;
    this.getAnalyticsData(this.tenantId, this.propertyId);
  }

  async getLocalJSON() {
    const tokenResponse = await this.getAzureBlobStorageToken();
    if (tokenResponse.success) {
      let url = this.getConfigUrl() + '/config/json%20files/uiMessageCofig.json?' + new Date().getTime() + '&' + tokenResponse.token;
      return this.http
        .get(url)
        .toPromise()
        .then(async (response) => {
          // this.rGuestSpaMessages = response['uiMessages'];
          return true;
        });
    }
  }

  private getAzureBlobStorageToken(): Promise<any> {
    const url = this.middlewareAPIDomain + ADMIN_SERVICE_URL + AZURE_BLOB_STORAGE_URL;
    return this.http.get(url).toPromise();
  }

  async propertyAPI() {
    return this.getPropertyDetails().then(async () => {
      return this.processThemeService().then(async () => {
        return true;
      });
    });
  }

  async getPropertyDetails() {
    let url =
      this.middlewareAPIDomain +
      '/wbe-spa-service/spa/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.propertyId +
      '/propertyInfo?appName=spa';
    return this.http
      .get(url, this.serviceHeaders)
      .toPromise()
      .then(
        async (response: SpaPropertyInfoApiResponse) => {
          if (response['success']) {
            this.propertyInfo = response;
            this.bookingDaysOut =
              this.propertyInfo && this.propertyInfo['rBookConfig']
                ? Number(this.propertyInfo['rBookConfig'].rBookBookingDaysOut)
                : this.bookingDaysOut;
            let currentPropertyDTTMDate = moment(this.propertyInfo['spaHeader']['propertyDTTM']).format('YYYY-MM-DD');
            let propertyDateInSettings = moment(this.propertyInfo['spaPropertySettings']['propertyDate']).format('YYYY-MM-DD');
            moment(currentPropertyDTTMDate, 'YYYY-MM-DD').isSameOrBefore(moment(propertyDateInSettings, 'YYYY-MM-DD'))
              ? (this.currentPropertyDate = propertyDateInSettings)
              : (this.currentPropertyDate = currentPropertyDTTMDate);
            this.propertyInfo['spaHeader']['propertyDTTM'] = this.currentPropertyDate + 'T00:00:00';
            this.setDisplayIndicator();
          } else this.tenantFound = false;
          return true;
        },
        (error) => {
          this.tenantFound = false;
        }
      );
  }

  private setDisplayIndicator(): void {
    if (this.propertyInfo['rBookConfig']) {
      switch (this.propertyInfo['rBookConfig'].rBookTherapistDisplay) {
        case 1:
          this.therapistDisplayIndicator = 'code';
          break;
        case 2:
          this.therapistDisplayIndicator = 'name';
          break;
        case 3:
          this.therapistDisplayIndicator = 'aka';
          break;
        case 4:
          this.therapistDisplayIndicator = 'noDisplay';
          break;
        default:
          this.therapistDisplayIndicator = 'name';
          break;
      }
    }
  }

  async setProperty() {
    this.pageTitle = this.cloudPropertyData.pageTitle ? this.cloudPropertyData.pageTitle : 'rGuest Book SPA UI';
    this.countryCodeKey = this.cloudPropertyData.countryCodeKey ? this.cloudPropertyData.countryCodeKey : 'alpha-2';
    this.dateFunctionConfig = this.cloudPropertyData.dateFunctionConfig
      ? this.cloudPropertyData.dateFunctionConfig
      : this.dateFunctionConfig;
    this.cartLimit = this.cloudPropertyData.cartLimit ? this.cloudPropertyData.cartLimit : 10;
    this.confirmationNumberLength = this.cloudPropertyData.confirmationNumberLength
      ? this.cloudPropertyData.confirmationNumberLength
      : this.confirmationNumberLength;
    this.paymentRetryInterval = this.cloudPropertyData.paymentRetryInterval
      ? this.cloudPropertyData.paymentRetryInterval
      : this.paymentRetryInterval;
    this.paymentRetryCounter = this.cloudPropertyData.paymentRetryCounter
      ? this.cloudPropertyData.paymentRetryCounter
      : this.paymentRetryCounter;
    this.cookieRequired = this.cloudPropertyData.permissions?.functionalPermissions?.isCookiePolicyRequired;
    this.isCookiePolicyAcceptanceRequired = this.cloudPropertyData.permissions?.functionalPermissions?.isCookiePolicyAcceptanceRequired;
    if (this.cookieRequired) {
      this.checkPolicyCookie();
    } else {
      this.googleAnalytics();
    }
    if (this.cloudPropertyData.UrlMap.MaintenaceStatus == 'true') {
      this.processThemeService().then(() => {
        this.tenantFound = true;
        return true;
      });
    } else {
      this.setPropertyNameConfig();
    }
  }

  private setPropertyNameConfig(): any {
    for (let prop in this.cloudPropertyData.PropNameKeyList) {
      if (prop == 'config') {
        this.propertyname_config = this.cloudPropertyData.PropNameKeyList[prop];
      }
    }
    return true;
  }

  async processThemeService() {
    const tokenResponse = await this.getAzureBlobStorageToken();
    if (tokenResponse.success) {
      return this.http
        .get(this.cloudPropertyData.UrlMap.StylUrl + '?' + new Date().getTime() + '&' + tokenResponse.token, { responseType: 'text' })
        .toPromise()
        .then(async (val: any) => {
          let style = val;
          return this.injectStylesheet(style, 'spa-app-theme-from-adminportal').then(async (appthemes) => {
            return true;
          });
        });
    }
  }

  async injectStylesheet(css, id) {
    const head = document.head || document.getElementsByTagName('head')[0];
    this.styleTag = document.createElement('style');
    this.styleTag.type = 'text/css';
    this.styleTag.id = id;
    this.styleTag.textContent = css;
    head.appendChild(this.styleTag);
    return true;
  }

  checkPolicyCookie() {
    this.policyCookie = this.getPolicyCookie(`${this.tenantId}-${this.propertyId}-policyCookie`);
    if (this.policyCookie) {
      this.googleAnalytics();
    }
  }

  //get localstorage cookie policy
  getPolicyCookie(cname) {
    let name = `${cname}=`;
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (const cookie of ca) {
      let c = cookie;
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let newupdatedate = new Date(c.substring(cname.length, c.length));
        this.setPolicyCookie(cname, newupdatedate, this.cookieExpDays ? this.cookieExpDays : 0);
        return true;
      }
    }

    return false;
  }

  //set cookie policy
  setPolicyCookie(cname, cvalue, exdays) {
    let expires;
    if (exdays != 0) {
      let d = new Date(cvalue);
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = `expires=${d['toGMTString']()}`;
    }
    document.cookie = `${cname}=${cvalue};${expires ? expires : ''};path=/`;
  }

  //setup google Analytics
  googleAnalytics() {
    this.loadGoogleScript(this.propertySettings);

    if (this.isGoogleTagManager && this.tagGoogleManagerId !== '') {
      const googleTagManagerScript = document.createElement('script');
      googleTagManagerScript.textContent = `window.dataLayer = window.dataLayer || [];
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${this.tagGoogleManagerId}');`;
      document.head.appendChild(googleTagManagerScript);
    }
  }

  generateUniqueID(tenantId, propertyId) {
    this.transactionID = Guid.create();
    localStorage.setItem(`${tenantId}-${propertyId}-transactionID`, JSON.stringify(this.transactionID));
  }

  private getConfigUrl(): string {
    return this.azureAccountUrl;
  }
}
